// src/components/QuickContact/QuickContact.js
import React from 'react';
import './QuickContact.css';

// Import icons from react-icons (FontAwesome set)
import { FaPhone, FaWhatsapp, FaEnvelope } from 'react-icons/fa';

const QuickContact = () => {
  return (
    <div className="quickcontact-container">
      <a
        href="tel:+919346359910" // Replace with your phone number
        className="quickcontact-icon quickcontact-call"
        title="Call Me"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaPhone />
      </a>
      <a
        href="https://wa.me/+919346359910" // Replace with your WhatsApp number
        className="quickcontact-icon quickcontact-whatsapp"
        title="Message on WhatsApp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp />
      </a>
      <a
        href="mailto:sriharimuppalla64@gmail.com" // Replace with your email address
        className="quickcontact-icon quickcontact-email"
        title="Email Me"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaEnvelope />
      </a>
    </div>
  );
};

export default QuickContact;